import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import SSOAuth from "./plugins/auth";
import vuetify from "./plugins/vuetify";
import { VueMaskDirective } from "v-mask";
import IdleVue from "idle-vue";
import "./plugins/aria-combobox";

Vue.directive("mask", VueMaskDirective);

Vue.config.productionTip = false;

const eventsHub = new Vue();

Vue.use(SSOAuth);

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 1800000,
  store
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
